import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../api/api.service';

/**
 * The data type returned by the API call that requests
 * categories for the current user
 */
export interface DocumentNavigationCategory {
  category_id: number,
  category_name: string,
  document_count: number,
}

/**
 * The data type returned by the API call that requests
 * types for a given category
 */
export interface DocumentNavigationType {
  type_id: number,
  category_id: number,
  document_count: number,
  type_name: string,
}

@Injectable({
  providedIn: 'root'
})
export class DocumentFoldersService {

  private readonly baseUrl = 'document-navigation'; // Base route for the documents API

  constructor(private apiService: ApiService) {}

  /**
   * Retrieves a list of all document categories and the number of files that the
   * current user has in those categories
   * @returns Promise<DocumentNavigationCategory[]> - The list of document navigation categories.
   */
  async getCategories(): Promise<DocumentNavigationCategory[]> {
    return this.apiService.call<DocumentNavigationCategory[]>(HttpMethod.GET, `${this.baseUrl}/categories`);
  }

  async getTypes(category_id: number): Promise<DocumentNavigationType[]> {
    return this.apiService.call<DocumentNavigationType[]>(HttpMethod.GET, `${this.baseUrl}/categories/${category_id}/types`);
  }

}
